<template>
  <div class="profile-tab-wrap">
    <a-tabs v-model="activeKey" ref="tabs">
      <a-tab-pane key="system" tab="System Notifications">
        <Notifications title="System Notifications" :data="SystemData" />
      </a-tab-pane>
      <a-tab-pane key="upgrade" tab="Upgrade Notifications" v-if="onlyClubCoach() || onlyPlayer()">
        <Notifications title="Upgrade Notifications" :data="SystemData" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import Notifications from "./notification-detail";
import { SystemData } from "./data";
export default {
  components: {
    Notifications
  },
  data() {
    return {
      SystemData,
      activeKey: "system"
    };
  }
};
</script>
<style lang="scss"></style>
